<div class="ltms-description">{{ mainDiscription }}</div>
<div class="table-widget">
    <div *ngIf="!restrictToday">
        <app-ltms-widget-tools [config]='widgetConfig'></app-ltms-widget-tools>
    </div>
    <!-- not needed now, If needed please enable it -->
    <!-- <div class="litmus-page-view-paging">
    <button [disabled]="!pagingButtons.isFirst">
        <img src="assets/images/angle-double-left.svg" />
    </button>
    <button  [disabled]="!pagingButtons.isPrevious">
        <img src="assets/images/angle-left.svg" />
    </button>
    <span [class.disabled]="pagingDetails.total <= 0"> {{pagingDetails.start}} - {{pagingDetails.end}} of {{pagingDetails.total}} </span>
    <button [disabled]="!pagingButtons.isNext">
        <img src="assets/images/angle-right.svg" />
    </button>
    <button [disabled]="!pagingButtons.isLast">
        <img src="assets/images/angle-double-right.svg" />
    </button>
</div> -->
</div>
<div class="table">
    <div *ngIf="isDataLoaded">
        <ng-container *ngIf="isDataAvailable && !restrictToday; else restrictionOrError">
            <app-ltms-data-table-v2 [columns]="columns" [data]="tableData" [footerData]="footerData"
                [deviationComparisonLabel]="deviationComparisonLabel" [showDeviation]="isDeviationEnabled">
            </app-ltms-data-table-v2>
        </ng-container>
        <ng-template #restrictionOrError>
            <div *ngIf="restrictToday" class="no-data-message error-text">
                No data available for the current date range. Try changing the date range.
            </div>
            <div *ngIf="!isDataAvailable && !restrictToday">
                <app-ltms-error [code]="errorCode" style="padding: 0;"></app-ltms-error>
            </div>
        </ng-template>
    </div>
    <div class="data-details-loader" *ngIf="!isDataLoaded" style="height: 30vh;">
        <app-ltms-loader></app-ltms-loader>
    </div>
</div>